import { render, staticRenderFns } from "./UpdateMedia.vue?vue&type=template&id=35678268&scoped=true"
import script from "./UpdateMedia.vue?vue&type=script&lang=js"
export * from "./UpdateMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35678268",
  null
  
)

export default component.exports